import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  GetSubCategoryImage,
  GetProductCatWithoutPage,
  GetProductStatus,
  GetSubCategoryById,
  UpdateSubCategory,
  api_url,
} from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";

function EditSubcategory(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setSubcategoryViewMessage = props.setMessage;

  const [subcategoryData, setSubcategoryData] = useState({});
  const [editedSubcategoryData, setEditedSubcategoryData] = useState({});
  const { subcategoryid } = useParams();
  const [fetchData, setFetchData] = useState(false);
  const [newImage, setNewImage] = useState(null);
  const [statusData, setStatusData] = useState(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const imageInputRef = React.createRef();
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await GetSubCategoryById(
          subcategoryid,
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setSubcategoryData(response?.data?._doc);
        setEditedSubcategoryData(response?.data?._doc);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [fetchData]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
    (async () => {
      try {
        setLoading(true);
        const categoryResponse = await GetProductCatWithoutPage(
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setCategoriesData(categoryResponse.data.categories);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);


  const handleNameChange = (e) => {
    const temp = { ...editedSubcategoryData };
    temp.name = e.target.value;
    setEditedSubcategoryData(temp);
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
  };

  const handleDiscardClick = async () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
    setNewImage(null);
    const temp = { ...subcategoryData };
    setEditedSubcategoryData(temp);
    navigate("/subcategory");
  };

  const handleStatusChange = (e) => {
    const temp = { ...editedSubcategoryData };
    temp.statusid = e.target.value;
    setEditedSubcategoryData(temp);
  };

  const handleSubcategoryIDChange = (e) => {
    const temp = { ...editedSubcategoryData };
    temp.categoryid = e.target.value;
    setEditedSubcategoryData(temp);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (editedSubcategoryData.name === "") {
        toast.error("Subcategory Name is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append("subcategoryid", editedSubcategoryData.subcategoryid);
    formData.append("name", editedSubcategoryData.name);
    formData.append("statusid", editedSubcategoryData.statusid);
    if (newImage) {
      formData.append("image", newImage);
      formData.append("imagename", editedSubcategoryData.image);
    }
    try {
      setEditLoading(true);
      response = await UpdateSubCategory(
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setEditLoading(false);
        toast.success("Store Updated Successfully");
        setSubcategoryViewMessage(response.data.message);
        navigate("/subcategory");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setEditLoading(false);
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setEditLoading(false);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Subcategory</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/subcategory" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div
            role="tabpanel"
            className="personal-info tab-pane active storetab"
            id="pi"
          >
            {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
            <div className="row">
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                {/* <div className="form-floating mb-4"> */}
                <label htmlFor="floatingInput" className="mb-2">
                  Category
                </label>
                <select
                  className="form-select"
                  onChange={handleSubcategoryIDChange}
                  value={editedSubcategoryData?.categoryid || ""}
                  disabled
                >
                  {categoriesData?.map((item) => (
                    <option value={item.categoryid} key={item.categoryid}>
                      {item.name}
                    </option>
                  ))}
                </select>
                {/* </div> */}
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                {/* <div className="form-floating mb-4"> */}
                <label htmlFor="catName">Name</label>
                <input
                  type="text"
                  value={editedSubcategoryData?.name}
                  onChange={handleNameChange}
                  className="form-control custom-input my-2"
                  id="catName"
                  placeholder="Product Main Category Name"
                />
                {/* </div> */}
              </div>

              <div className="form-group col-sm-12 col-lg-6 mb-3">
                {/* <div className="form-floating mb-4"> */}
                <label htmlFor="catImg">Image</label>
                <input
                  type="file"
                  ref={imageInputRef}
                  className="form-control custom-input my-2"
                  id="catImg"
                  onChange={handleImageChange}
                  placeholder="Product Main Category Image"
                />
                <img
                  width="50px"
                  height="50px"
                  src={`${api_url}/product/category/getSubcategoryImage/${editedSubcategoryData?.image}`}
                />
                {/* </div> */}
              </div>
            </div>

            <label htmlFor="floatingInput">Status</label>
            <select
              className="form-select custom-input my-2"
              onChange={handleStatusChange}
              value={editedSubcategoryData?.statusid}
            >
              {statusData?.map((item) => (
                <option value={item.statusid}>{item.status}</option>
              ))}
            </select>
            <div className="row">
              <div
                className="col-12 d-flex"
                style={{ height: "40px", width: "120px" }}
              >
                <button
                  type="submit"
                  onClick={handleDiscardClick}
                  disabled={editLoading}
                  style={{ height: "100%", width: "100%" }}
                  className="btn btn-danger save-btn text-uppercase"
                >
                  Discard
                </button>{" "}
                &nbsp;
                {editLoading ? (
                  <div
                    className="btn btn-primary loader-active save-btn"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <RiLoaderFill
                      size={20}
                      className="spin-animation"
                      color="white"
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    disabled={editLoading}
                    onClick={handleSubmitClick}
                    className="btn btn-primary save-btn text-uppercase"
                    style={{ height: "100%", width: "100%" }}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        <hr />
      </div>
    </div>
  );
}
export default EditSubcategory;
